import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { get } from "lodash";
import { LogoutUser, logoutReset } from "../../actions/onLoadFunctionAction";
import history from "../../history";
import { LOCAL_STORAGE_KEYS, LOGGED_IN, RouteName, VERSION_KEY, VERSION_VALUE } from "../../constants/Constants";
import storage from "../../services/storage";
import { loginSuccess, verifyOtpSuccess } from "../../actions/loginAction";
import { resetAllSessionListReducerObj } from "../../actions/sessionListAction";
import { resetAllSessionDetailReducerObj } from "../../actions/sessionDetailAction";
import { resetActiveUsersReducerObj } from "../../actions/activeUsersActions";
import SignalR from '../../services/signalR';
import { resetLDIdentification } from "../../shared/launchDarklyUtility";

const Logout = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { onLoadData } = useSelector((state) => state);
  const { logoutLoading, logoutData, logoutError } = onLoadData;

  useEffect(() => {
    const payload = {
      isLogoutAll: false,
      autoLogout: get(location, 'state.AUTOLOGOUT', false)
    };
    if (!logoutLoading && !logoutData && !logoutError) {
      dispatch(LogoutUser(payload));
    }
  }, []);

  useEffect(() => {
    const clearData = async () => {
      try {
        const userLanguage = storage.get(LOCAL_STORAGE_KEYS.USERS_LANGUAGE);

        storage.clearAll();
        await SignalR.Disconnect(); // wait for SignalR disconnect
        storage.set(LOCAL_STORAGE_KEYS.USERS_LANGUAGE, userLanguage);
        localStorage.setItem(LOGGED_IN, "0");
        storage.set(VERSION_KEY, VERSION_VALUE);

        // Reset LaunchDarkly identification tracking
        resetLDIdentification();

        dispatch(resetAllSessionListReducerObj());
        dispatch(resetAllSessionDetailReducerObj());
        dispatch(resetActiveUsersReducerObj());
        dispatch(logoutReset());
        dispatch(verifyOtpSuccess(false));
        dispatch(loginSuccess(false));

        history.push(RouteName.LOGIN);
      } catch (err) {
        console.error("Error during logout cleanup:", err);
      }
    };
    if (logoutData) {
      clearData();
    }
  }, [logoutData]);

  return (
    <div className="full-height-loader">
      <div className="full-height-loader-in">
        <div className="full-height-loader-box">
          <div className="loader">
            <span className="for-icon icon-loader spin"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logout;
